module.exports = __webpack_public_path__ + "static/media/shield.1a01e12e.svg";